import { useMutation, useQueryClient } from '@tanstack/react-query';

import { abandonedCheckoutsApi } from '../api/abandoned-checkouts-api';

import { abandonedCheckoutKeys } from './abandoned-checkout-keys';

/**
 * 409 with `meta.reason` exactly when `canSendRecovery` is false. The detail is refetched for its
 * recovery history, which the response does not carry.
 */
export function useSendRecovery(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => abandonedCheckoutsApi.sendRecovery(storeId, id),
    meta: { successMessage: 'abandonedCheckouts:toasts.sent', silentError: true },
    onSuccess: (checkout) => {
      void queryClient.invalidateQueries({
        queryKey: abandonedCheckoutKeys.detail(storeId, checkout.id),
      });
      return queryClient.invalidateQueries({ queryKey: abandonedCheckoutKeys.lists(storeId) });
    },
  });
}
